var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "发送邮件",
        visible: _vm.dialogVisible,
        top: "5vh",
        width: "70%",
        "before-close": _vm.handleClose
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { staticClass: "TicketMailSendDialogForm" },
        [
          _c(
            "el-form-item",
            { attrs: { label: "工单" } },
            [
              _c("el-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.ticketSubject,
                  callback: function($$v) {
                    _vm.ticketSubject = $$v
                  },
                  expression: "ticketSubject"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "邮件标题" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.mailSubject,
                  callback: function($$v) {
                    _vm.mailSubject = $$v
                  },
                  expression: "mailSubject"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label:
                  "邮件内容(工单内容会自动作为邮件内容, 这里填写附加的其他内容)"
              }
            },
            [
              _c("el-input", {
                attrs: { type: "textarea" },
                model: {
                  value: _vm.mailContent,
                  callback: function($$v) {
                    _vm.mailContent = $$v
                  },
                  expression: "mailContent"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label:
                  "收件人邮箱(你希望把邮件发送给谁, 可以英文分号分隔填入多个)"
              }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.mailTo,
                  callback: function($$v) {
                    _vm.mailTo = $$v
                  },
                  expression: "mailTo"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "抄送(可以英文分号分隔填入多个)" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.mailCc,
                  callback: function($$v) {
                    _vm.mailCc = $$v
                  },
                  expression: "mailCc"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "回复到(当对方回复邮件时候, 你希望谁收到)" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.replyTo,
                  callback: function($$v) {
                    _vm.replyTo = $$v
                  },
                  expression: "replyTo"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("取消")]),
          _vm._v(" "),
          _c("el-button", { on: { click: _vm.doMailPreview } }, [
            _vm._v("预览")
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.doMailSend } },
            [_vm._v("发送")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14829496", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14829496","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketMailSendDialog.vue
// module id = 950
// module chunks = 75